import React, { Component } from 'react';
import PropTypes from 'prop-types';
import VerificationStore from './stores/VerificationStore';
import { VerificationHeader, VerificationFooter } from './components/verification';
import { VerificationContainer } from './containers';

class VerificationApp extends Component {
  state = {
    verificationStatus: '',
    loading: false,
    restricted: false,
  };

  componentDidMount() {
    const {
      verificationStatus,
      verificationImage,
      myStatus,
      myImage,
      myGender,
      adminComment,
      isSimulated,
    } = this.props;

    VerificationStore.setVerificationStatus(verificationStatus);
    if (verificationStatus === 'unverified') {
      VerificationStore.setError('txt: Atvaino, mēs nevarējām verificēt Tavu bildi');
      VerificationStore.setForceRetake(true);
    }

    VerificationStore.setExampleImage(myGender);
    VerificationStore.setCapturedImage(verificationImage, true);

    VerificationStore.setDisabled(myStatus);
    VerificationStore.setNeedActivate(myStatus);
    VerificationStore.setNeedImage(myImage);

    VerificationStore.setAdminComment(adminComment);

    VerificationStore.setIsSimulated(isSimulated);

    VerificationStore.addChangeListener(this.onChange);

    VerificationStore.emitChange();
  }

  componentWillUnmount() {
    VerificationStore.removeChangeListener(this.onChange);
  }

  onChange = () => {
    this.setState({
      verificationStatus: VerificationStore.getVerificationStatus(),
      loading: VerificationStore.getLoading(),
      restricted: VerificationStore.getRestricted(),
    });
  };

  render() {
    const {
      verificationStatus,
      loading,
      restricted,
    } = this.state;

    const {
      showContactInfo,
      verificationRestrictions,
      messagesCharacterLimit,
    } = this.props;

    return (
      <div className={`verification block${loading ? ' loading' : ''}`}>
        {loading && (
          <div className="loading-spinner loading-spinner--vcenter" />
        )}
        <VerificationHeader
          verificationStatus={verificationStatus}
          verificationRestrictions={verificationRestrictions}
          messagesCharacterLimit={messagesCharacterLimit}
          restricted={restricted}
        />
        {(restricted || !['pending', 'verified'].includes(verificationStatus)) && (
          <VerificationContainer
            showContactInfo={showContactInfo}
          />
        )}
        <VerificationFooter />
      </div>
    );
  }
}

VerificationApp.propTypes = {
  verificationStatus: PropTypes.string,
  verificationImage: PropTypes.string,
  myStatus: PropTypes.string,
  myImage: PropTypes.string,
  myGender: PropTypes.string,
  adminComment: PropTypes.string,
  isSimulated: PropTypes.bool,
  showContactInfo: PropTypes.bool,
  verificationRestrictions: PropTypes.bool,
  messagesCharacterLimit: PropTypes.number,
};

VerificationApp.defaultProps = {
  verificationStatus: '',
  verificationImage: '',
  myStatus: '',
  myImage: '',
  myGender: '',
  adminComment: '',
  isSimulated: false,
  showContactInfo: false,
  verificationRestrictions: false,
  messagesCharacterLimit: null,
};

export default VerificationApp;
